import { render } from "./ServerLogs.vue?vue&type=template&id=6c450ede"
import script from "./ServerLogs.vue?vue&type=script&lang=js"
export * from "./ServerLogs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__